module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_0.55d215b8.png";